import React, { forwardRef } from 'react';
import { Link } from 'react-router-dom';

import { styled } from '@mui/material/styles';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';

const LoadingContent = styled('div')({
  position: 'relative'
});

const HiddenContent = styled('div')({
  visibility: 'hidden'
});

const LoaderContainer = styled('div')({
  position: 'absolute',
  left: '50%',
  top: 0,
  transform: 'translate(-50%, 0)'
});

export const VpButton = ({ loading = false, to = '', loadingIconSize = 40, children, ...rest }) => {
  const linkButtonProps = to
    ? {
        to, // eslint-disable-next-line react/display-name
        component: forwardRef((props, innerRef) => <Link innerRef={innerRef} {...props} />),
        sx: {
          '&:hover': {
            color: 'white'
          }
        }
      }
    : {};

  return (
    <Button disabled={loading} {...linkButtonProps} {...rest}>
      {loading ? (
        <LoadingContent>
          <HiddenContent>{children}</HiddenContent>
          <LoaderContainer>
            <CircularProgress size={loadingIconSize} sx={{ p: 1, color: 'vpColors.white' }} />
          </LoaderContainer>
        </LoadingContent>
      ) : (
        children
      )}
    </Button>
  );
};

VpButton.propTypes = {
  loading: PropTypes.bool,
  to: PropTypes.string,
  children: PropTypes.node,
  loadingIconSize: PropTypes.number
};

export default VpButton;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpButton.jsx